import apiClient from './api';

export default {
    async getSources(params = {}) {
        try {
            const response = await apiClient.get('/sources', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching sources:', error);
            throw error;
        }
    },

    async getSource(id) {
        try {
            const response = await apiClient.get(`/sources/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching source ${id}:`, error);
            throw error;
        }
    },

    async createSource(data) {
        return apiClient.post('/sources', data);
    },

    async updateSource(id, data) {
        return apiClient.put(`/sources/${id}`, data);
    },

    async deleteSource(id) {
        return apiClient.delete(`/sources/${id}`);
    }
};
